// extracted by mini-css-extract-plugin
export default {"root":"YUDvgTGA","closeButton":"QstuwOeC","stepCounter":"HwNnmlf6","stepLabel":"EMzTf7IQ"};